export const getGoogleMapsUrlFromPlaceId = (placeId: string) => {
  return `https://www.google.com/maps/dir/?api=1&destination_place_id=${placeId}&destination=${encodeURIComponent(
    placeId,
  )}`;
};
